<template>
    <AlertBar :message="''" class="trialcontentwrapper" v-if="has_running_trial" :variant="'banner'">
        <template #message>
            <div style="display: flex; gap: 4px;">
                <span>{{ trial_message }}</span>
                <span class="activationctatext" @click="go_to_billing(false)">
                    Klikk her for å oppgradere.
                </span>
            </div>
        </template>
    </AlertBar>
    <AlertBar :message="''" class="trialcontentwrapper"
        v-if="!has_running_trial && !paid_subscription && is_authenticated" :variant="'banner'">
        <template #message>
            <div style="display: flex; gap: 4px;">
                <span>Du har ikke et aktivt abonnement, og din prøveperiode har utløpt.</span>
                <span class="activationctatext" @click="go_to_billing(true)">
                    Klikk her for å oppgradere.
                </span>
            </div>
        </template>
    </AlertBar>

</template>

<script setup lang="ts">
import AlertBar from '@/components/AlertBar.vue';
import { useAmplitudeStore } from '@/stores/amplitude';
import { useAnalyticsStore } from '@/stores/analytics';

import { useMeStore } from '@/stores/me';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';

const me_store = useMeStore();
const { trial_message, has_running_trial, paid_subscription } = storeToRefs(me_store);
const { is_authenticated } = storeToRefs(me_store);
const amplitude = useAmplitudeStore();
const analytics = useAnalyticsStore();





const router = useRouter();
const go_to_billing = (is_expired: boolean) => {
    if (is_expired) {
        amplitude.track('Expired Trial CTA Clicked', {})
        analytics.track('Expired Trial CTA Clicked', 'trialmessage.expired.clicked', 'maiamd.mymaia.client.trialmessage', 'Expired trial message was clicked by user');
    }
    else {
        amplitude.track('Trial CTA Clicked', {});
        analytics.track('Trial CTA Clicked', 'trialmessage.active.clicked', 'maiamd.mymaia.client.trialmessage', 'Trial message was clicked by user');
    }
    router.push({ name: 'profile.billing' });
};

</script>


<style lang="scss" scoped>
.trialcontentwrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    gap: 24px;
    align-self: stretch;
}


span {
    color: var(--Text-Title, #151515);
    font-family: Saans;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
}

.activationctatext {
    color: var(--Text-Title, #151515);
    font-family: Saans;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
    text-decoration: underline;
    cursor: pointer;
}
</style>
